import React from "react";
import { useLocation } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import useIdleSignOut from "../../hooks/useIdleSignOut";

// Pages that are not part of a signed-in session: the landing/sign-in
// page, external folder shares, the Word panel (its own sign-in) and the
// document view framed inside Salesforce (a pass in the address).
const PUBLIC_PREFIXES = ["/shared-folder/", "/word-addin", "/embed/"];

export function isSessionPage(pathname) {
  if (!pathname || pathname === "/") return false;
  return !PUBLIC_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

function timeLeft(secondsLeft) {
  const minutes = Math.ceil(secondsLeft / 60);
  if (secondsLeft < 60) return "less than a minute";
  return minutes === 1 ? "1 minute" : `${minutes} minutes`;
}

const SessionKeeper = () => {
  const { pathname } = useLocation();
  const { secondsLeft, staySignedIn } = useIdleSignOut(isSessionPage(pathname));

  return (
    <Dialog open={secondsLeft !== null} onClose={staySignedIn} maxWidth="xs">
      <DialogTitle>Still there?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          WHG Docs signs you out after an hour without activity. You will be
          signed out in {secondsLeft !== null ? timeLeft(secondsLeft) : ""}.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={staySignedIn} autoFocus>
          Stay signed in
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionKeeper;
